<script>
import abbreviate from 'number-abbreviate';
import moment from 'moment';

import { SectionPostTypes } from '../../constants';

export default {
  name: 'CpSocialFeedPetitionPost',
  data() {
    return {
      showLikesModal: false,
      comments_count: this.petition.comments_count,
      showSignModal: false,
      isSigned: this.petition.signed,
      type: SectionPostTypes.PETITIONS,
    };
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginBottom: require('../../directives/margins').marginBottom,
    marginTop: require('../../directives/margins').marginTop,
  },
  components: {
    PersonIcon: require('../icons/person').default,
    PetitionInfoIcon: require('../icons/petition_info').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpSocialShareDialog: require('../../dialogs/social-share').default,
    LikeActionButton: require('../actions/like-action-button').default,
    CpLikesProfiles: require('../../likes/likes-profiles').default,
    CpDialog: require('../../dialog').default,
    CpButtonLink: require('../../button-link').default,
    CpButton: require('../../button').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    CpPetitionSign: require('../../dialogs/sign-petition').default,
    SignActionButton: require('../actions/sign-action-button').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpCardHeaderReactions: require('../../components/CardHeaderReactions').default,
    CpShowInteractionsCount: require('../../components/ShowInteractionsCount').default,
    CpShowImageInCard: require('../../components/ShowImageInCard').default,
    CpTruncateText: require('../../components/TruncateText').default,
  },
  props: {
    petition: { type: Object, default: () => {} },
    explore: Boolean,
    forShare: Boolean,
    user: [Object, Boolean],
  },
  methods: {
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleCountLikes(value) {
      value ? (this.petition.likes_count = this.petition.likes_count + 1) : (this.petition.likes_count = this.petition.likes_count - 1);
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
    profile(slug) {
      return '/profile/' + slug;
    },
    handleSignModal() {
      this.showSignModal = !this.showSignModal;
    },
    setPetitionSigned() {
      this.isSigned = true;
    },
  },
  computed: {
    petitionImage() {
      return JSON.parse(this.petition.image);
    },
    petitionOwnerImage() {
      return JSON.parse(this.petition.owner.image);
    },
    dateDiff() {
      var date_now = moment.utc().local();
      var date_created_at = moment.utc(this.petition.created_at).local();
      if (date_now.diff(date_created_at, 'days') < 30) {
        return true;
      } else {
        return false;
      }
    },
    authUser() {
      return this.$root.authUser;
    },
    descriptionText() {
      //remove html tags so that vue clamp works properly
      return this.petition.description.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ');
    },
    signatureCountFormatted() {
      return abbreviate(this.petition.signatures_count, 1);
    },
    redirectOwner() {
      if (this.petition.owner.type == 'candidate' || this.petition.owner.type == 'organization' || this.petition.owner.type == 'mixed') {
        return this.petition.owner.slug;
      } else if (this.petition.owner.type == 'user') {
        return '/profile/' + this.petition.owner.slug;
      } else {
        return null;
      }
    },
    isPetitionSigned() {
      return this.isSigned;
    },
  },
  watch: {
    isSigned(newValue, oldValue) {
      if (newValue) {
        this.isSigned = newValue;
      }
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <!-- TO DO: uncomment this when we implement the new feed logic -->
    <!-- <div v-if="explore && petition.last_activity && !forShare && petition.last_activity.action != 'signed'" style="display: flex">
      <CpCardHeaderReactions :post="petition.last_activity" />
    </div>

    <div v-else-if="explore && petition.last_activity && !forShare && petition.last_activity.action == 'signed'" style="display: flex">
      <cp-grid spread stretch-content justify="spaceBetween">
        <cp-grid-item span="content" align="center">
          <a v-if="petition.last_activity.image && petition.last_activity.first_name != 'Anonymous'">
            <img :src="petition.last_activity.image" class="image-user-activity" />
          </a>
          <span class="center-user">
            <a class="content-2 profile-link a-hidden">
              <span v-if="petition.last_activity.first_name">
                {{ petition.last_activity.first_name }}
              </span>
              <span v-if="petition.last_activity.last_name">
                {{ petition.last_activity.last_name[0] }}
              </span>
            </a>
            <span class="content-1"> {{ petition.last_activity.action }}</span>
          </span>
        </cp-grid-item>
      </cp-grid>
    </div>
    <hr v-if="explore && petition.last_activity && !forShare" class="search-results__tick_action" /> -->

    <div class="social-feed-post-profile-wrapper">
      <div class v-if="!!petition.owner.type">
        <a :href="redirectOwner">
          <img
            v-if="$root.imgAdjustedWithVersion(this.petitionOwnerImage)"
            :src="$root.croppedImgWithVersion(this.petitionOwnerImage, 70, 70)"
            class="profile-img"
          />
          <img v-else-if="$root.imgNotAdjustedWithVersion(this.petitionOwnerImage)" :src="$root.imgWithVersion(this.petitionOwnerImage)" class="profile-img" />
          <img
            v-else-if="$root.imgAdjustedNoVersion(this.petitionOwnerImage)"
            :src="$root.croppedImgNoVersion(this.petitionOwnerImage, 70, 70)"
            class="profile-img"
          />
          <img v-else-if="$root.imgNotAdjusted(this.petitionOwnerImage)" :src="this.petition.owner.imageUrl" class="profile-img" />
          <span v-else class="profile-img social-feed-default-img" :class="{ iconOwner: forShare }">
            <cp-base-svg-icon
              class
              :width="60"
              :height="60"
              :viewBox="'0 0 100 125'"
              :icon-color="'#ff4814'"
              :stroke-color="'none'"
              :class="{ iconOwner: forShare }"
            >
              <person-icon />
            </cp-base-svg-icon>
          </span>
        </a>
      </div>
      <div v-else>
        <span class="profile-img social-feed-default-img" :class="{ iconOwner: forShare }">
          <cp-base-svg-icon :width="60" :height="60" :viewBox="'0 0 100 125'" :icon-color="'#ff4814'" :stroke-color="'none'" :class="{ iconOwner: forShare }">
            <person-icon />
          </cp-base-svg-icon>
        </span>
      </div>
      <div class="mini-recipient">
        <a :class="{ ownerNameUnderline: !forShare || explore, ownerName: forShare }" :href="redirectOwner">
          <span class="profile-name mini-recipient__title" v-if="petition.owner.name">{{ petition.owner.name }}</span>
        </a>
      </div>
    </div>
    <a :href="`${petition.permalink}?ref_code=social-feed`" class="subheadline1 black-color" v-margin="0.5">{{ petition.name }}</a>
    <CpShowImageInCard
      v-if="$root.imgAdjustedNoVersion(this.petitionImage)"
      :image="`https://res.cloudinary.com/crowdpac/image/upload/c_crop,h_${Math.floor(this.petitionImage.settings.height)},w_${Math.floor(
          this.petitionImage.settings.width,
        )},x_${Math.floor(this.petitionImage.settings.x)},y_${Math.floor(this.petitionImage.settings.y)}/c_fill,f_auto,q_auto/v1/${
          this.petitionImage.id
        }`"
      :link="`${petition.permalink}?ref_code=social-feed`"
    />
    <CpShowImageInCard
      v-else-if="$root.imgNotAdjusted(this.petitionImage)"
      :image="`https://res.cloudinary.com/crowdpac/image/upload/v1/${this.petitionImage.id}`"
      :link="`${petition.permalink}?ref_code=social-feed`"
    />
    <CpShowImageInCard
      v-else
      :image="`https://res.cloudinary.com/crowdpac/image/upload/v1/${this.petitionImage.id}`"
      :link="`${petition.permalink}?ref_code=social-feed`"
    />
    <a v-else :href="`${petition.permalink}?ref_code=social-feed`" class="social-feed-post-link">
      <div class="social-feed-post-img-placeholder">
        <span class="profile-img social-feed-default-img">
          <cp-base-svg-icon
            :width="$root.isMobile ? 50 : 60"
            :height="$root.isMobile ? 50 : 60"
            :viewBox="'0 0 70 125'"
            :icon-color="'currentColor'"
            :stroke-color="'none'"
            :class="{ iconPost: forShare }"
          >
            <petition-info-icon />
          </cp-base-svg-icon>
        </span>
      </div>
    </a>
    <div class="social-feed-post-description">
      <CpTruncateText :content="descriptionText" />
    </div>
    <a :href="`${petition.permalink}?ref_code=social-feed`" class="social-feed-post-link">View Petition</a>
    <div class="social-feed-post-actions">
      <div class="post-action share-feed">
        <div class="post-action-button primary" :class="{ iconPerson: forShare }">
          <cp-base-svg-icon :width="40" :height="40" :viewBox="'0 0 100 125'" :icon-color="'white'" :stroke-color="'none'">
            <person-icon />
          </cp-base-svg-icon>
        </div>
        <div class="post-action-text">{{ signatureCountFormatted }}</div>
      </div>
    </div>

    <div v-if="!forShare" style="margin-top: 10px !important">
      <CpShowInteractionsCount
        :type="type"
        :id="petition.id"
        :likesCount="petition.likes_count"
        :commentsCount="comments_count"
        :handleLikesModal="handleLikesModal"
      />
    </div>

    <cp-dialog v-if="showLikesModal && !forShare">
      <cp-likes-profiles :count-likes="petition.likes_count" :id="petition.id" :type="'petitions'" @close="handleLikesModal"></cp-likes-profiles>
    </cp-dialog>

    <div v-if="!forShare" class="social-feed-post-actions">
      <div class="post-action-button like">
        <like-action-button type="petitions" :id="petition.id" :liked="petition.liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button comment">
        <comment-action-button :type="type" :id="petition.id" />
      </div>
      <div class="post-action-button like">
        <sign-action-button :handleSignModal="handleSignModal" :isSigned="isPetitionSigned" />
      </div>
      <div class="post-action-button share">
        <cp-social-share-dialog
          class="feed"
          :allow-share-feed="true"
          :type="'petitions'"
          :explore="explore"
          share-category="Petition"
          :post="petition"
          share-button-class="button--noborder"
          :url="petition.permalink"
          title="Petitions found via CrowdBlue - Social Network For Politics"
          :description="`Wanted to share this petitions article I found on CrowdBlue, the Social Network for Politics.`"
          quote
          hashtags="crowdBlue,politics,political crowdfunding"
          twitter-user="crowdblue"
        ></cp-social-share-dialog>
      </div>
    </div>

    <cp-comments-post
      v-show="!forShare"
      :id="petition.id"
      :type="type"
      :setCount="setCommentsCount"
    >
    </cp-comments-post>

    <cp-petition-sign
      v-if="authUser && showSignModal"
      :petition_id="petition.id"
      :loggedin="true"
      :user="{
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        zip: user.address_zip,
      }"
      :handleDialog="handleSignModal"
      :setPetitionSigned="setPetitionSigned"
    >
    </cp-petition-sign>
    <cp-petition-sign
      v-else-if="!authUser && showSignModal"
      :petition_id="petition.id"
      :loggedin="false"
      :user="{
        first_name: '',
        last_name: '',
        email: '',
        zip: '',
      }"
      :handleDialog="handleSignModal"
    >
    </cp-petition-sign>
  </div>
</template>

<style scoped>
.ownerName:hover {
  text-decoration: none;
}
.ownerNameUnderline:hover {
  text-decoration: underline;
  color: #000000;
}
.a-hidden {
  text-decoration: none;
}
.center-user {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-user-activity {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  margin-right: 10px;
}
.social-feed-post-title {
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
  font-family: var(--sans-font);
}
div.post-action-text {
  padding-left: 5px;
  font-size: 1.1em;
}
div.post-action-button {
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
}
div.post-action-button.primary {
  background: linear-gradient(to right, #f83600, #fe8c00);
}
div.post-action.share-feed {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
a.social-feed-post-link {
  color: var(--primary);
}
a.social-feed-post-link:hover {
  color: var(--primary);
  text-decoration: none;
}
div.social-feed-post-profile-wrapper .profile-img {
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  width: 60px;
  height: 60px;
  -o-object-fit: contain;
  object-fit: contain;
}
div.social-feed-post-profile-wrapper {
  display: flex;
  flex-direction: row;
}
div.social-feed-post-profile-wrapper .details-wrapper {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
}

div.social-feed-post-profile-wrapper .profile-name {
  font-size: 1.2em;
}

div.social-feed-post-profile-wrapper .post-time {
  color: #666;
}

img.social-feed-post-img {
  max-width: 100%;
  max-height: 100%;
  min-width: 100%;
}
span.social-feed-default-img {
  display: flex;
  align-items: center;
  justify-content: center;
}
a.social-feed-post-link {
  display: block;
  padding-top: 10px;
  font-size: 1.1em;
}

div.social-feed-post-wrapper {
  width: 100%;
  padding: 1.5em;
  border-bottom: 2px solid var(--neutral3);
  margin-bottom: 2.5em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
}
div.social-feed-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.social-feed-post-wrapper > * {
  width: 100%;
}

.mini-recipient__subtitle {
  margin-top: 0px;
}

div.social-feed-box-wrapper.mobile img.social-feed-post-img {
  min-height: 45vh;
  object-fit: cover;
}
.social-feed-default-img {
  background: #ffe3da;
  color: var(--highlight);
}
div.social-feed-box-wrapper.mobile div.social-feed-post-wrapper {
  padding: 0.7em;
}
div.social-feed-post-img-placeholder {
  min-height: 400px;
  background: rgb(233, 94, 54);
  background: linear-gradient(180deg, rgba(233, 94, 54, 1) 65%, rgba(254, 130, 94, 1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
header.social-feed-title-header {
  text-align: center;
  margin: 30px 0px;
}
div.social-feed-post-description {
  padding-top: 10px;
}
video.candidate-video-player {
  width: 100%;
  height: auto;
}
.profile-img.social-feed-default-img svg {
  margin-top: 10px;
}

.social-feed-sidebar {
  position: fixed;
}

.header-label {
  font-size: 16px;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 600;
  color: #121212;
}

.mobile-fixed-bottom-sidebar .social-feed-right-sidebar {
  padding: 15px;
  position: relative;
  max-width: 100% !important;
}

.small-desktop-right-sidebar .social-feed-right-sidebar {
  max-width: 12.2vh;
}

.small-desktop-right-sidebar .title-3 hr {
  display: none;
}

.mobile-fixed-bottom-sidebar {
  position: fixed;
  background: white;
  width: 100% !important;
  bottom: 0px;
  left: 0px;
  margin: 0px;
}

.search-results__tick_like {
  color: #cacaca;
  width: 50px;
}

.search-results__tick_action {
  color: #cacaca;
  width: 50px;
  margin-right: auto;
}

a.profile-link {
  color: var(--color);
}

.iconPerson {
  width: 40px;
}

.profile-img {
  border-radius: 50%;
  width: 60px;
  height: 60px;
}

div.post-action-button.share div.feed svg.iconOwner,
.iconOwner,
div.post-action-button.share div.feed svg.iconPost,
.iconPost {
  width: 60px !important;
  height: 60px !important;
}
</style>
